import { useQuery } from '@tanstack/react-query';

import { indexArrayByPropName } from '@shared/utils';

import { fetchAgreementTemplatesForPeriod } from '@ManagerPortal/api/schedule/agreements';

import { SCHEDULE_DATA_CACHE_TIME } from '../useFetchScheduleData';
import { useGetScheduleDataHookParams } from '../utils/useGetScheduleDataHookParams';

export const QUERY_KEY =
  '/v1/employee/agreement-templates/by-group/{groupId}/for-workers';

export const useAgreementTemplatesQuery = () => {
  const { currentGroupId, start, end, isPlaceholderFilterData } =
    useGetScheduleDataHookParams();

  const agreementTemplatesQuery = useQuery({
    queryKey: [QUERY_KEY, start, end, currentGroupId],
    queryFn: async () => {
      const res = await fetchAgreementTemplatesForPeriod(
        start,
        end,
        currentGroupId,
      );
      return res?.body;
    },
    select: (data) => indexArrayByPropName(data),
    enabled: !isPlaceholderFilterData,
    cacheTime: SCHEDULE_DATA_CACHE_TIME,
  });

  return agreementTemplatesQuery;
};
